import matter from 'gray-matter';
import { remark } from 'remark';
import remarkGfm from 'remark-gfm';
import html from 'remark-html';

// Client-side loader: prefer /public/documents with fallback to /public/documentations; convert to HTML
export async function getDocumentBySlugClient(slug) {
  const publicUrl = (typeof process !== 'undefined' && process.env && process.env.PUBLIC_URL) ? process.env.PUBLIC_URL : '';
  const primaryPath = `${publicUrl}/documents/${slug}.md`;
  const fallbackPath = `${publicUrl}/documentations/${slug}.md`;
  let response = await fetch(primaryPath, { cache: 'no-cache' });
  if (!response.ok) {
    // try fallback for compatibility
    const fallbackResponse = await fetch(fallbackPath, { cache: 'no-cache' });
    if (!fallbackResponse.ok) {
      throw new Error(`Failed to fetch ${primaryPath} or ${fallbackPath}`);
    }
    response = fallbackResponse;
  }
  const raw = await response.text();
  let contentOnly = '';
  let metadata = {};
  try {
    const parsed = matter(raw);
    contentOnly = parsed && typeof parsed.content === 'string' ? parsed.content : raw;
    metadata = parsed && parsed.data ? parsed.data : {};
  } catch (_e) {
    // Fallback: strip any frontmatter block bounded by --- ... --- at the top
    contentOnly = raw.replace(/^---[\s\S]*?---\s*/, '');
  }
  const processed = await remark().use(remarkGfm).use(html).process(contentOnly);
  const contentHtml = processed.toString();
  return {
    slug,
    title: metadata?.title || '',
    lastUpdated: metadata?.lastUpdated || '',
    description: metadata?.description || '',
    contentHtml,
  };
}


